import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import { api } from "../../lib/api";
import { useRoleBase } from "../../hooks/useRoleBase";
import { Card, PageHeader, EmptyState, Spinner, StatusPill } from "../../components/dashboard/DashboardShell";
import { fmtDate, RECOMMENDATION_META } from "../../lib/format";

export default function ReportsPage() {
  const base = useRoleBase();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["reports"], queryFn: () => api.get("/reports").then((r) => r.data) });
  return (
    <div>
      <PageHeader title="Laporan Inspeksi" subtitle="Semua laporan hasil inspeksi yang tersedia." />
      {isLoading ? <Spinner /> : !data?.length ? <Card><EmptyState icon="file" title="Belum ada laporan" desc="Laporan muncul setelah inspector menyelesaikan inspeksi." /></Card> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="reports-grid">
          {data.map((r) => {
            const rec = RECOMMENDATION_META[r.recommendation] || RECOMMENDATION_META.layak;
            const scoreColor = r.score >= 85 ? "text-emerald-600 bg-emerald-50" : r.score >= 65 ? "text-amber-500 bg-amber-50" : "text-red-500 bg-red-50";
            return (
              <button key={r.report_id} onClick={() => navigate(`${base}/pesanan/${r.order_id}`)} data-testid={`report-card-${r.report_id}`}
                className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 text-left hover:shadow-md hover:border-blue-200 transition-all">
                <div className="flex items-start justify-between gap-3">
                  <span className="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center"><FileText size={18} /></span>
                  <span className={`text-lg font-extrabold rounded-xl px-3 py-1 ${scoreColor}`}>{r.score}</span>
                </div>
                <p className="text-sm font-extrabold text-slate-900 mt-3">{r.order?.vehicle_type_label} {r.vehicle_info?.brand ? `· ${r.vehicle_info.brand} ${r.vehicle_info.model || ""}` : ""}</p>
                <p className="text-xs text-slate-500 mt-1 line-clamp-2">{r.summary}</p>
                <div className="flex items-center justify-between mt-4 gap-2 flex-wrap">
                  <span className={`text-white text-[10px] font-bold rounded-full px-2.5 py-1 ${rec.cls}`}>{rec.label}</span>
                  <span className="text-[11px] text-slate-400">{fmtDate(r.submitted_at)}</span>
                </div>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-slate-50">
                  <span className="text-[11px] font-bold text-slate-500">{r.order_id}</span>
                  {r.order?.status && <StatusPill status={r.order.status} />}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
